import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-soc-mall-soc-ops",
  "use": "icon-soc-mall-soc-ops-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 1024 1024\" id=\"icon-soc-mall-soc-ops\">\n<g transform=\"translate(-80 -80) scale(1.18)\" fill=\"currentColor\">\n  <circle cx=\"512\" cy=\"280\" r=\"72\" />\n  <rect x=\"200\" y=\"420\" width=\"140\" height=\"88\" rx=\"16\" />\n  <rect x=\"442\" y=\"420\" width=\"140\" height=\"88\" rx=\"16\" />\n  <rect x=\"684\" y=\"420\" width=\"140\" height=\"88\" rx=\"16\" />\n  <rect x=\"320\" y=\"620\" width=\"140\" height=\"88\" rx=\"16\" />\n  <rect x=\"564\" y=\"620\" width=\"140\" height=\"88\" rx=\"16\" />\n  <path d=\"M512 352v68M270 420V388c0-24 88-48 242-48s242 24 242 48v32M390 508v112M634 508v112\" fill=\"none\" stroke=\"currentColor\" stroke-width=\"36\" />\n</g>\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/icons/svg/soc-mall-soc-ops.svg
// module id = sTiI
// module chunks = 477